import webapi from '../../api/webapi'
/**
   通常設定
*/

const state = {
}

const getters = {
}

// actions
const actions = {
  /**
    初期設定（伝票照会APIをコールする）
  */
  StaffCall({ commit,getters,dispatch}, callmode) {
    
    return new Promise((resolve, reject) => {
      webapi
        .request(
          'call',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
            call_mode:  callmode,
          }
        )
        .then(result => {
          dispatch('showLogMessage','call スタッフ呼び出しAPI')//実行ログ
          resolve(result)
        })
        .catch(errors => {
          dispatch('showErrorMessage',getters.ConvertAppError(errors))
          reject()
        })
      
    })
    
  },
}

// mutations
const mutations = {

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/call.js